<template>
  <div class="eth-pool">
    <div class="pool-header">
      <div class="arrow-icon" @click="back">
        <img src="../assets/arrow-left.png" />
      </div>
      <div class="title">
        Pool Status
      </div>
    </div>
    <div class="pool-items">
      <div class="pool-item" :class="{'pool-item2': contractAddress != ''}">
        <div class="item-left">
          <div class="left-text">
            Minted rETH
          </div>
        </div>
        <div class="item-right">
          <div class="amount-text">
            {{ totalRETH }}
          </div>
          <div v-if="contractAddress != ''" class="detail-text">
            Contract address: {{ contractAddress }}
          </div>
        </div>
      </div>

      <div class="pool-item pool-item2">
        <div class="item-left">
          <div class="left-text">
            Staked ETH
          </div>
        </div>
        <div class="item-right">
          <div class="amount-text">
            {{ totalStakedETH }}
          </div>
          <div class="detail-text">
            Pool Contracts: {{ poolCount }}
          </div>
        </div>
      </div>

      <div class="pool-item">
        <div class="item-left">
          <div class="left-text">
            Unmatched ETH
          </div>
        </div>
        <div class="item-right">
          <div class="amount-text">
            {{ unmatchedETH }}
          </div>
        </div>
      </div>

      <div class="pool-item pool-item2">
        <div class="item-left">
          <div class="left-text">
            Unmatched Validators
          </div>
        </div>
        <div class="item-right">
          <div class="amount-text">
            {{ unmatchedValidators }}
          </div>
          <!-- <div class="detail-text">
            You rank 3rd in the matching queen
          </div> -->
        </div>
      </div>

      <div class="pool-item pool-item2">
        <div class="item-left">
          <div class="left-text">
            Validators APR
          </div>
        </div>
        <div class="item-right">
          <div class="amount-text">
            {{ validatorApr }}
          </div>
          <div class="detail-text">
            Estimated
          </div>
        </div>
      </div>

      <div class="pool-item pool-item2">
        <div class="item-left">
          <div class="left-text">
            Staker APR
          </div>
        </div>
        <div class="item-right">
          <div class="amount-text">
            {{ stakerApr }}
          </div>
          <div class="detail-text">
            Estimated
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Rpc from '../util/rpc.js';
import Web3Util from '../util/web3Util.js';
import NumberUtil from '../util/numberUtil.js';
import StringUtil from '../util/stringUtil.js';

export default {
  name: 'ethpool',
  data() {
    return {
      contractAddress: '',
      totalRETH: '0.0000',
      poolCount: 0,
      totalStakedETH: '--',
      unmatchedETH: '0.0000',
      unmatchedValidators: 0,
      stakerApr: '--',
      validatorApr: '--',
      source: ''
    }
  },
  created() {
    if (this.$route.params) {
      this.source = this.$route.params.source;
      this.contractAddress = this.$route.params.contractAddress || '';
      if (this.contractAddress) {
        this.contractAddress = StringUtil.replacePkh(this.contractAddress, 4, 38);
      }
    }

    let address = '0x0000000000000000000000000000000000000000';
    let web3 = Web3Util.getWeb3();
    let contract = new web3.eth.Contract(Web3Util.getRETHTokenAbi(), Web3Util.getRETHTokenAddress(), {
      from: address
    });
    contract.methods.totalSupply().call().then(result => {
      let totalRETH = parseFloat(web3.utils.fromWei(result, 'ether'));
      this.totalRETH = NumberUtil.handleEthAmountToFixed(totalRETH);
    });

    let managerContract = new web3.eth.Contract(Web3Util.getStafiStakingPoolManagerAbi(), Web3Util.getStafiStakingPoolManagerAddress(), {
      from: address
    });
    managerContract.methods.getStakingPoolCount().call().then(poolCount => {
      this.poolCount = poolCount;
    });

    let userContract = new web3.eth.Contract(Web3Util.getStafiUserDepositAbi(), Web3Util.getStafiUserDepositAddress(), {
      from: address
    });

    userContract.methods.getBalance().call().then(result => {
      let unmatchedETH = parseFloat(web3.utils.fromWei(result, 'ether'));
      this.unmatchedETH = NumberUtil.handleEthAmountToFixed(unmatchedETH);
    });

    let poolQueueContract = new web3.eth.Contract(Web3Util.getStafiStakingPoolQueueAbi(), Web3Util.getStafiStakingPoolQueueAddress(), {
      from: address
    });

    poolQueueContract.methods.getLength('2').call().then(result => {
      this.unmatchedValidators = result;
    });

    Rpc.fetchStakingPoolStatus({}).then(result => {
      if (result.status == '80000') {
        if (result.data) {
          if (result.data.stakeAmount) {
            this.totalStakedETH = NumberUtil.handleEthAmountToFixed(result.data.stakeAmount);
          }
          if (result.data.validatorApr) {
            this.validatorApr = result.data.validatorApr + '%';
          }
          if (result.data.stakerApr) {
            this.stakerApr = result.data.stakerApr + '%';
          }
        }
      } 
    });
  },
  methods: {
    back() {
      this.$router.push({ name: 'reth', params: {source: this.source}});
    }
  }
}
</script>

<style lang="scss">
@import "../mixin.scss";

.eth-pool {
  background-color: #2B3239;
  width: 683px;
  height: 535px;
  border-radius: 19px;
  padding: 0 20px;

  .pool-header {
    display: flex;
    margin-left: 43px;
    margin-bottom: 30px;

    .arrow-icon {
      cursor: pointer;
      margin-top: 40px;
      margin-right: 20px;
      height: 23px;
      img {
        height: 100%;
      }
    }
    
    .title {
      font-size: 30px;
      font-weight: bold;
      margin-top: 35px;
    }
  }

  .pool-items {

    .pool-item {
      display: flex;
      border-bottom: 1px solid #474747;
      padding-bottom: 20px;
      margin-top: 24px;

      .item-left {
        margin-left: 72px;
        width: 253px;

        .left-text {
          font-size: 16px;
        }
      }

      .item-right {
        .amount-text {
          font-size: 20px;
          font-weight: bold;
        }

        .detail-text {
          margin-top: 3px;
          font-size: 12px;
          color: #7C7C7C;
        }
      }

    }

    .pool-item2 {
      padding-bottom: 10px;
    }
  }
}
</style>
